export default {
    name: "date_add",
    definition: {
        init: function () {
            this.jsonInit({
                "message0": 'Add %1 %2to date%3',
                "args0": [
                    {
                        "type": "input_value",
                        "name": "AMOUNT",
                        "check": "Number"
                    },
                    {
                        "type": "field_dropdown",
                        "name": "GRANULARITY",
                        "options": [
                            ["days", "DAYS"],
                            ["weeks", "WEEKS"],
                            ["months", "MONTHS"],
                            ["years", "YEARS"]
                        ]
                    },
                    {
                        "type": "input_value",
                        "name": "DATE"
                    },
                ],
                "inputsInline": true,
                "output": "Boolean",
                "colour": 4.5,
                "tooltip": "Compares two dates",
                "helpUrl": "http://www.w3schools.com/jsref/jsref_length_string.asp"
            });
        }
    },
    codeGenerator: (blocklyInstance) => function (block) {

        const javaChronoUnit = `java.time.temporal.ChronoUnit`
        const date = blocklyInstance.JavaScript.valueToCode(block, "DATE", blocklyInstance.JavaScript.ORDER_ATOMIC);
        const amount = blocklyInstance.JavaScript.valueToCode(block, "AMOUNT", blocklyInstance.JavaScript.ORDER_ATOMIC);
        const granularity = block.getFieldValue("GRANULARITY");
        return [`${date}.plus(${amount}, Java.type("${javaChronoUnit}").${granularity})`, blocklyInstance.JavaScript.ORDER_NONE];
    }
}